<div matSnackBarLabel [ngClass]="{'text-green-600 dark:text-green-500': mode() === 'success',
                       'text-red-600 dark:text-red-500': mode() === 'error',
                       'text-yellow-600 dark:text-yellow-500': mode() === 'warning',
                       'text-blue-600 dark:text-blue-500': mode() === 'info'}">
    {{message()}}
</div>
<!-- Circular Progress -->
<div class="relative size-10 m-auto" matSnackBarActions>
    <svg class="size-full -rotate-90" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
        <!-- Background Circle -->
        <circle cx="18" cy="18" r="16" fill="none" [ngClass]="{'text-green-600 dark:text-green-500': mode() === 'success',
                       'text-red-600 dark:text-red-500': mode() === 'error',
                       'text-yellow-600 dark:text-yellow-500': mode() === 'warning',
                       'text-blue-600 dark:text-blue-500': mode() === 'info'}" class="stroke-current" stroke-width="2">
        </circle>
        <!-- Progress Circle -->
        <circle cx="18" cy="18" r="16" fill="none" class="stroke-current text-white-600 dark:text-white-500"
            stroke-width="2" stroke-dasharray="100" [attr.stroke-dashoffset]="dashOffset" stroke-linecap="round">
        </circle>
    </svg>

    <!-- Percentage Text -->
    <div class="absolute top-1/2 start-1/2 transform -translate-y-1/2 -translate-x-1/2">
        <button mat-icon-button matSnackBarAction (click)="snackBarRef.dismissWithAction()" class="text-white">
            <mat-icon [svgIcon]="'heroicons_solid:x-mark'" class="text-white"></mat-icon>
        </button>
        <!-- <span class="text-center text-2xl font-bold text-blue-600 dark:text-blue-500">35%</span> -->
    </div>
</div>
<!-- End Circular Progress -->